import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface JobExtensionInProgressProgressionActionsProps {
  onUploadExtensionConfirmation: () => unknown
}

export function JobExtensionInProgressProgressionActions({
  onUploadExtensionConfirmation,
}: JobExtensionInProgressProgressionActionsProps) {
  return (
    <CardContent>
      <Button
        label="Upload Extension Confirmation"
        variant="primary"
        size="wide-slim"
        onPress={onUploadExtensionConfirmation}
        testId="job-progression-set-upload-extension-confirmation-button"
      />
    </CardContent>
  )
}
